<div class="filter-bar-container">
    <div class="title">Sort by</div>
    <div class="filters d-flex align-items-center">
        <select class="sort-select" #sortby (change)="sortData(sortby.value, 'ASC')">
            <option *ngFor="let options of sortingOptions" [value]="options.value">{{options.display}}
            </option>
        </select>
        <div class="sort-direction-wrapper">
            <span *ngIf="sortingOrder == 'DESC'; else ASC" (click)="sortData(sortby.value,'ASC')" class="sort-icon">
                <div class="chevron north"></div>
            </span>
            <ng-template #ASC>
                <span (click)="sortData(sortby.value,'DESC')" class="sort-icon">
                    <div class="chevron south"></div>
                </span>
            </ng-template>
        </div>
    </div>
</div>